import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ICompanyQPViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreClientsService } from '@services/cleanfill-core/store-clients/store-clients.service';
import { AuthService } from '@services/core/auth.service';
import { SearchQuery } from '@view-models/search-query/search-query';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class ClientResolver implements Resolve<ICompanyQPViewModel | ICompanyQPViewModel> {
  constructor(private clientStore: StoreClientsService, private authService: AuthService) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<ICompanyQPViewModel> {
    const clientUniqueId = route.params.clientUniqueId;

    if (!clientUniqueId) {
      return Promise.resolve(undefined);
    }

    const companySelected = this.clientStore.companySelected;

    if (companySelected) {
      return Promise.resolve(companySelected);
    }
    const legalentityid = (await this.authService.activeUserLegalEntityUniqueId$.pipe(filter(Boolean), take(1)).toPromise()) as string;
    return this.clientStore.loadSelectedClient(legalentityid, clientUniqueId, new SearchQuery());
  }
}
